import { render, staticRenderFns } from "./pageEditor.vue?vue&type=template&id=05767225&scoped=true"
import script from "./pageEditor.vue?vue&type=script&lang=js"
export * from "./pageEditor.vue?vue&type=script&lang=js"
import style0 from "./pageEditor.vue?vue&type=style&index=0&id=05767225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05767225",
  null
  
)

export default component.exports